import React, { useState, useEffect, useMemo, memo } from 'react';
import { useSelector } from 'react-redux';
import { Box } from '@material-ui/core';
import { isSameDay, set, parseISO, isBefore } from 'date-fns';
import { convertToTimeZone } from 'date-fns-timezone';

import { convertObjToArr } from '../../../../../../utils';
import Slot from '../../Slot';
import useStyles from './styles';

const now = new Date();

const ColumnDay = ({ slots, date, loaded }) => {
  const classes = useStyles();
  const { timetable } = useSelector(
    state => state.appointments.schedule.columns,
  );
  const [loading, setLoading] = useState(false);
  const [slotsPopulated, setSlotsPopulated] = useState([]);

  const timeTableArr = useMemo(() => convertObjToArr(timetable), [timetable]);

  useEffect(() => {
    setLoading(!loaded);
  }, [loaded]);

  const parsedDate = useMemo(() => {
    const dateParsed = parseISO(date);
    const parsedTimeZone = convertToTimeZone(dateParsed, {
      timeZone: 'UTC',
    });
    return parsedTimeZone;
  }, [date]);

  useEffect(() => {
    setSlotsPopulated(() =>
      timeTableArr.map(({ id, startTime }) => {
        const slotIndex = slots.findIndex(slot => slot.timeTableId === id);
        if (slotIndex > -1) {
          if (isSameDay(parsedDate, now)) {
            const [startTimeHour, startTimeMinutes] = startTime.split('h');
            const dateWithTime = set(parsedDate, {
              hours: startTimeHour,
              minutes: startTimeMinutes,
            });
            if (isBefore(dateWithTime, now)) {
              return { ...slots[slotIndex], status: 'BEFORE_NOW' };
            }
          }
          return slots[slotIndex];
        }
        return { timeTableId: id, status: 'EMPTY' };
      }),
    );
  }, [slots, parsedDate, timeTableArr]);

  return (
    <Box className={classes.container}>
      <Box className="column-content">
        {loading && <Slot loading />}
        {slotsPopulated &&
          !loading &&
          slotsPopulated.map(slot => (
            <Slot key={slot.timeTableId} slotInfos={slot} columnDate={date} />
          ))}
      </Box>
    </Box>
  );
};

export default memo(ColumnDay);
